<template>
  <div class="wrapper">
    <div class="pitures">
      <van-swipe class="swiper-wrapper" :loop="false" indicator-color="#E64D4C" @change="onChange">
        <van-swipe-item class="image-container" v-for="(image, index) in article.coverImages" :key="index">
          <img class="pitures-item" :src="image.url" :style="`height: ${swiperHeight}px`" alt="" />
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="article">
      <div class="title">{{ article.title }}</div>
      <div class="meta">
        <span class="mr20">{{ time }}</span>
        <span>{{ article.source }}</span>
      </div>
      <div class="content" v-dompurify-html="article.content"></div>
    </div>
  </div>
</template>
<script>
import { Image, Swipe, SwipeItem } from 'vant';
import dayjs from 'dayjs';
import { formatTimeLength } from '@/views/detailPage/utils/time';
export default {
  name: 'Pictures',
  props: {
    article: {
      type: Object
    },
  },
  components: {
    [Image.name]: Image,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
  },
  computed: {
    time() {
      return this.article.time ? dayjs(formatTimeLength(this.article.time)).format('YYYY年M月D日 hh:mm') : '';
    },
    swiperHeight() {
      const item = this.article.coverImages[0];
      if (item) {
        return item.height / item.width * document.documentElement.clientWidth;
      } else {
        return 0;
      }
    },
  },
  data() {
    return {
      current: 0,
    };
  },
  methods: {
    onChange(index) {
      this.current = index;
    }
  }
};
</script>
<style lang="less" scoped>
.image-container {
  width: 100%;
  height: 100%;
  position: relative;

  .pitures-item {
    min-height: 200px;
    max-height: 500px;
    width: 100%;
    margin-bottom: 30px;
    object-fit: contain;
  }
}

/deep/.van-swipe__indicator {
  background-color: #DCDFE6;
}

.article {
  padding: 0 20px;

  .title {
    font-size: 16px;
    font-weight: 600;
    line-height: 22px;
    margin-bottom: 14px;
  }

  .meta {
    font-size: 14px;
    line-height: 20px;
    color: #909399;
    margin-bottom: 14px;
  }

  .content {
    font-size: 16px;
    line-height: 22px;
    margin-bottom: 20px;
  }
}

.mr20 {
  margin-right: 20px;
}

.night {
  .title {
    color: #d2d2d3;
  }

  .content {
    color: #d2d2d3;
  }
}
</style>
